/**
 * Custom service form
 */
class CustomerServiceForm {
  /**
   * @constructor
   * @param {HTMLElement} element HTMLElement object to bind functionality
   */
  constructor(element) {
    this._form = element;

    this._typeInputs = Array.from(this._form.querySelectorAll('input[name="type"]'));

    this._bind();

    this._forms = {
      contact: this._form.querySelectorAll('form.asiakaspalvelu')[0],
      feedback: this._form.querySelectorAll('form.asiakaspalvelu')[1],
    };

    this._handleLocations();
  }

  /**
   * Bind events
   */
  _bind() {
    this._typeInputs.forEach(input => {
      input.addEventListener('click', this._formTypeChanges.bind(this));
    });

    if (window.multiselects?.brand) {
      window.multiselects.brand.addCallback({
        onValueChange: () => {
          this._handleLocations();
        }
      });
    }

    // On feedback form don't require location selection on specified subjects
    if (window.multiselects?.subject2) {
      window.multiselects.subject2.addCallback({
        onValueChange: () => {
          const storeSelectElement = window.multiselects.store.element;
          const storeSelectContainer = storeSelectElement.closest('.form-v10__field');

          if (window.multiselects.subject2?.value) {
            const subjectsWithoutStoreRequirement = ['Palaute nettisivuista', 'Muu aihe'];
            const selectedSubject = window.multiselects.subject2.value[0];

            if (subjectsWithoutStoreRequirement.includes(selectedSubject)) {
              // Unrequire store selection
              storeSelectContainer.classList.remove('stage-required', 'stage-error');
              storeSelectContainer.querySelector('.form-v10__input-error').remove();
            } else {
              // Re-require store selection
              storeSelectContainer.classList.add('stage-required');
            }
          }
        }
      });
    }
  }

  /**
   * Hide and show the selected form
   */
  _formTypeChanges() {
    const selectedType = this._typeInputs.find(o => o.checked).value;

    if (this._forms.contact) {
      this._forms.contact.style.display = selectedType === 'contact' ? 'block' : 'none';
    }

    if (this._forms.feedback) {
      this._forms.feedback.style.display = selectedType === 'feedback' ? 'block' : 'none';
    }
  }

  /**
   * Hide and show location options based on brand selection
   */
  _handleLocations() {
    if (window.multiselects?.brand) {
      const selectedBrand = window.multiselects.brand.options.find(option => option.selected);
      const locationIds = selectedBrand?.datasets.find(dataset => dataset.datasetName === 'locations')?.datasetValue?.split(',') || [];

      // Hide and show options
      window.multiselects.location?.options?.forEach((option, key) => {
        if (locationIds.length && !locationIds.includes(option.value) && option.value) {
          window.multiselects.location.hideOption(key);
        } else {
          window.multiselects.location.showOption(key);
        }
      });
    }
  }

  /**
   * Initialize the customer service form on the page.
   * @static
   */
  static init() {
    document.querySelectorAll('.customer-service').forEach(element => {
      new CustomerServiceForm(element);
    });
  }
}

export default CustomerServiceForm;
